import * as t from 'io-ts';

export const TemplateCategoryCodec = t.type({
  id: t.number,
  title: t.string,
  language: t.string,
  slug: t.string,
});

export const TemplateCategoryList = t.type({
  data: t.array(TemplateCategoryCodec),
});
